import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import * as contractHooks from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.hooks";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import {
  DisplayText,
  ESpacings,
  Grid,
} from "@rentiohq/web-shared/dist/components";
import { DocumentOverview } from "../../../../components/Documents";

interface IProps {
  property: IProperty;
}

export const DocumentsOverview = (props: IProps) => {
  const { property } = props;

  const { items: contracts, isFetching: isFetchingContracts } =
    contractHooks.usePaged({
      query: {
        limit: CONFIG.DEFAULT_FETCH_LIMIT,
        page: 1,
        filter: {
          or: [
            {
              and: [
                { contractType: { eq: "basic" } },
                { propertyId: { eq: property.id } },
              ],
            },
          ],
        },
      },
      shouldRefetch: true,
    });

  return (
    <>
      <Grid
        mb={ESpacings.base}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid.Item>
          <DisplayText size="medium">{"Documents"}</DisplayText>
        </Grid.Item>
      </Grid>

      <DocumentOverview
        extraFilterData={{ propertyId: { eq: property.id } }}
        passPropsDocumentDetail={{ propertyId: property.id }}
        withTemplates={true}
        contracts={contracts}
        isFetchingContracts={isFetchingContracts}
      />
    </>
  );
};
